import { render, staticRenderFns } from "./exchange-success-popup.vue?vue&type=template&id=60a9f901&scoped=true&lang=pug&"
import script from "./exchange-success-popup.vue?vue&type=script&lang=js&"
export * from "./exchange-success-popup.vue?vue&type=script&lang=js&"
import style0 from "./exchange-success-popup.vue?vue&type=style&index=0&id=60a9f901&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9f901",
  null
  
)

export default component.exports